const stripHtmlToText = (value = '') => String(value || '')
  .replace(/<style[\s\S]*?<\/style>/gi, ' ')
  .replace(/<script[\s\S]*?<\/script>/gi, ' ')
  .replace(/<br\s*\/?\s*>/gi, ' ')
  .replace(/<[^>]+>/g, ' ')
  .replace(/&nbsp;/gi, ' ')
  .replace(/&amp;/gi, '&')
  .replace(/&lt;/gi, '<')
  .replace(/&gt;/gi, '>')
  .replace(/&quot;/gi, '"')
  .replace(/&#39;/gi, "'")
  .replace(/\s+/g, ' ')
  .trim();

const hasMeaningfulPrettyValue = (value = '') => !!stripHtmlToText(value);

/**
 * String Value vs Pretty Value is defined by the English/source shape of the
 * string, never by the target language itself. This keeps the runtime rule the
 * same for every locale now and in the future.
 */
const getRuntimeTextField = ({ englishData = {}, localeData = {} } = {}) => {
  const expectsPrettyValue = hasMeaningfulPrettyValue(englishData.prettyValue || '');

  if (expectsPrettyValue && localeData.prettyValue) {
    return {
      field: 'prettyValue',
      value: localeData.prettyValue,
      expectsPrettyValue,
    };
  }

  if (localeData.stringValue) {
    return {
      field: 'stringValue',
      value: localeData.stringValue,
      expectsPrettyValue,
    };
  }

  return {
    field: expectsPrettyValue ? 'prettyValue' : 'stringValue',
    value: localeData.prettyValue || localeData.stringValue || '',
    expectsPrettyValue,
  };
};

module.exports = {
  stripHtmlToText,
  hasMeaningfulPrettyValue,
  getRuntimeTextField,
};
